<div class="step-panel">

  <div class="pg-title">
    Final disbursal
    <span class="badge b-g" style="vertical-align:middle;margin-left:8px">Complete</span>
  </div>
  <div class="pg-sub">
    Loan disbursed to institute bank account. Application lifecycle complete.
  </div>

  <!-- NOT YET DISBURSED -->
  <ng-container *ngIf="!disbursalSuccess && !disbursalFailed">
    <div class="alert info">
      <span style="flex-shrink:0">ℹ</span>
      <span>Application is ready for disbursal. Click the button below to initiate the disbursal instruction.</span>
    </div>

    <div class="disb-dark">
      <div class="dd-hdr">Disbursal summary</div>
      <div class="dd-amount">₹{{ applicationData?.approvedAmount || applicationData?.requestedAmount || 0 | number }}</div>
      <div class="dd-dest">
        Approved amount · {{ applicationData?.tenureMonths || 0 }} months tenure
      </div>
      <div class="dd-grid">
        <div class="di">
          <div class="k">Application ID</div>
          <div class="v">{{ applicationData?.applicationId || '—' }}</div>
        </div>
        <div class="di">
          <div class="k">Status</div>
          <div class="v">{{ applicationData?.applicationStatus || '—' }}</div>
        </div>
        <div class="di">
          <div class="k">Approved by</div>
          <div class="v">{{ applicationData?.approvedBy || '—' }}</div>
        </div>
      </div>
    </div>

    <div style="text-align:center;padding:16px 0">
      <button class="btn btn-ok btn-lg" (click)="markDisbursed()" [disabled]="isDisbursing">
        <span *ngIf="!isDisbursing">Confirm & Disburse →</span>
        <span *ngIf="isDisbursing">Processing disbursal...</span>
      </button>
    </div>
  </ng-container>

  <!-- SUCCESS STATE -->
  <ng-container *ngIf="disbursalSuccess">
    <div class="disb-dark">
      <div class="dd-hdr">Disbursal complete</div>
      <div class="dd-amount">₹{{ applicationData?.disbursedAmount || applicationData?.approvedAmount || 0 | number }}</div>
      <div class="dd-dest">
        Disbursed on {{ applicationData?.disbursedOn ? (applicationData?.disbursedOn | date:'dd MMM yyyy, HH:mm') : 'Today' }}
      </div>
      <div class="dd-grid">
        <div class="di">
          <div class="k">Application ID</div>
          <div class="v">{{ applicationData?.applicationId || '—' }}</div>
        </div>
        <div class="di">
          <div class="k">Status</div>
          <div class="v" style="color:#6ee7b7">Disbursed</div>
        </div>
        <div class="di">
          <div class="k">Tenure</div>
          <div class="v">{{ applicationData?.tenureMonths || 0 }}M</div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-title">
        <div class="ct-bar" style="background:var(--green)"></div>
        Disbursal confirmation
      </div>
      <div class="cl-item">
        <div class="cl-icon cl-ok">✓</div>
        <span>Application status updated to Disbursed</span>
      </div>
      <div class="cl-item">
        <div class="cl-icon cl-ok">✓</div>
        <span>Disbursement amount recorded — ₹{{ applicationData?.disbursedAmount || 0 | number }}</span>
      </div>
      <div class="cl-item">
        <div class="cl-icon cl-ok">✓</div>
        <span>Disbursal date recorded</span>
      </div>
    </div>
  </ng-container>

  <!-- FAILURE STATE -->
  <div class="exc-state err" *ngIf="disbursalFailed" style="margin-top:14px">
    <div class="exc-title">Disbursal failed</div>
    <div class="exc-body">
      The disbursal instruction could not be processed. Please retry or escalate to finance.
    </div>
    <div class="exc-actions">
      <button class="btn btn-err btn-sm" (click)="retryDisbursal()" [disabled]="isRetrying">
        {{ isRetrying ? 'Retrying...' : 'Retry disbursal' }}
      </button>
    </div>
  </div>

  <!-- FINAL NAV -->
  <div class="nav-bar">
    <button class="btn btn-sec" (click)="prev.emit()">← Back</button>
    <button class="btn btn-pri" (click)="returnToDashboard()" *ngIf="disbursalSuccess">
      Return to dashboard
    </button>
  </div>

</div>
